<div [formGroup]="form">
    <app-website-config-form-expansion-panel [title]="'Social Media Links'" [firstMarginTop]="false">
        <div formArrayName="socialMediaLinks">
            @for (socialMediaLink of socialMediaLinksArray.controls; let i = $index; track socialMediaLink) {
            <div [formGroup]="socialMediaLink" class="admin-row no-border-bottom">

                <mat-form-field appearance="outline" class="form-field-width cell">
                    <mat-label>Plattform</mat-label>
                    <mat-select formControlName="platform" (selectionChange)="onPlatformChange(socialMediaLink, $event.value)" panelClass="admin-theme">
                        <mat-select-trigger>
                            <span class="platform-option">
                                <mat-icon class="platform-icon">{{ getPlatformIcon(socialMediaLink.get('platform')?.value) }}</mat-icon>
                                  {{ socialMediaLink.get('platform')?.value }}
                            </span>
                        </mat-select-trigger>
                        @for (platform of socialMediaPlatforms; track platform.value) {
                            <mat-option [value]="platform.value">
                                <span class="platform-option">
                                    <mat-icon class="platform-icon">{{ getPlatformIcon(platform.value) }}</mat-icon>
                                    {{ platform.label }}
                                </span>
                            </mat-option>
                        }
                    </mat-select>
                    @if(socialMediaLink.get('platform')?.hasError('required')) {
                        <mat-error>Bitte wählen Sie eine Plattform aus</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-field-width cell url-field">
                    <mat-label>URL</mat-label>
                    <input matInput formControlName="url" 
                           [placeholder]="getUrlPrefixForPlatform(socialMediaLink.get('platform')?.value) + getPlaceholderForPlatform(socialMediaLink.get('platform')?.value)">
                    @if(socialMediaLink.get('url')?.hasError('platformSpecific')) {
                        <mat-error>{{ socialMediaLink.get('url')?.getError('platformSpecific') }}</mat-error>
                    } @else if(socialMediaLink.get('url')?.hasError('invalidUrl')) {
                        <mat-error>{{ socialMediaLink.get('url')?.getError('invalidUrl') }}</mat-error>
                    } @else if (socialMediaLink.get('url')?.hasError('required')) {
                        <mat-error>Feld darf nicht leer sein</mat-error>
                    }
                    @if(socialMediaLink.get('platform')?.value) {
                        <mat-hint>Format: {{getUrlPrefixForPlatform(socialMediaLink.get('platform')?.value)}}{{getPlaceholderForPlatform(socialMediaLink.get('platform')?.value)}}</mat-hint>
                    }
                </mat-form-field>

                <mat-checkbox class="cell checkbox-cell" formControlName="isActive">Aktiv</mat-checkbox>

                <button mat-icon-button (click)="onDeleteSocialMediaLink(i)" class="delete-button">
                    <mat-icon class="admin-error">delete</mat-icon>
                </button>
            </div>
            <mat-divider></mat-divider>
            }
        </div>
        <div class="add-action">
            <button mat-mini-fab (click)="addSocialMediaLink()" matTooltip="Social Media Link hinzufügen">
                <mat-icon class="admin-success">add</mat-icon>
            </button>
        </div>
    </app-website-config-form-expansion-panel>
</div>